import * as React from 'react';
export const IcStarAdd = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.9 9.48a2 2 0 00-1.6-1.35l-4.47-.68-2-4.3a2 2 0 00-3.62 0l-2 4.3-4.51.68a2 2 0 00-1.6 1.35 2 2 0 00.47 2l3.29 3.38-.78 4.79a2 2 0 00.82 1.95 2 2 0 001.16.4c.35.009.695-.078 1-.25l4-2.2 4 2.2c.305.172.65.259 1 .25a2 2 0 001.16-.37 2 2 0 00.82-1.95l-.78-4.79 3.29-3.38a2 2 0 00.35-2.03zM14 14h-1v1a1 1 0 11-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1h1a1 1 0 110 2z'
      fill='currentColor'
    />
  </svg>
);
